// src/utils/axiosInstance.js
import axios from "axios";
import { useAuthStore } from "@/stores/auth.js";
import router from "@/router";
import { authChannel } from "@/utils/authChannel";
import { useDeviceStore } from "@/stores/device";

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL, // 👈 Para Vite
  headers: {
    Accept: "application/json",
  },
});

// 🔐 Interceptar requests para agregar el token
instance.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore();
    if (authStore.isLoggingOut) {
      return Promise.reject(new axios.CanceledError("Sesión en proceso de cierre.", config));
    }
    config.authSessionVersion = authStore.sessionVersion;
    const token = authStore.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
// 
    const deviceToken =
      localStorage.getItem("device_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (deviceToken) {
      config.headers["X-Device-Token"] = deviceToken;
    }

    const deviceStore = useDeviceStore();

    config.headers['X-Fingerprint'] = deviceStore.fingerprint;

    return config;
  },
  (error) => Promise.reject(error)
);

const isStaleResponse = (config, authStore) =>
  config?.authSessionVersion !== undefined &&
  config.authSessionVersion !== authStore.sessionVersion;

instance.interceptors.response.use(
  (response) => {
    const authStore = useAuthStore();
    if (authStore.isLoggingOut || isStaleResponse(response.config, authStore)) {
      return Promise.reject(new axios.CanceledError("Respuesta de una sesión cerrada.", response.config));
    }
    return response;
  },
  async (error) => {
    const authStore = useAuthStore();

    if (isStaleResponse(error.config, authStore)) {
      return Promise.reject(new axios.CanceledError("Respuesta de una sesión anterior.", error.config));
    }

    if (error.response?.status === 401) {
      console.warn("Token inválido o sesión expirada");
      await authStore.logout({ remote: false });

      // authChannel.postMessage({ type: "logout" });
      // if (router.currentRoute.value.name !== "login") {
      //   router.push({ name: "login" });
      // }
    }

    return Promise.reject(error);
  }
);

export default instance;
